Vue.asyncComponent('ak-import', {
    computed: {
        activeBundle() {
            return this.bundle ? this.bundle : this.$route.params.bundle;
        },
        activeDefinition() {
            return this.definition ? this.definition : this.$route.params.importDefinition;
        },
        activeStep() {
            return this.step ? this.step : 1;
        },
        baseUrl() {
            return this.$appKitUrl() + '/object-import/form-upload?importBundle=' + this.activeBundle + '&importDef=' + this.activeDefinition;
        },
        canImport() {
            return this.report.ok > 0
                && !this.report.hasFileErrors
                && (this.partialExecution || this.report.error === 0);
        }

    },
    props: {
        bundle: {
            type: String,
            required: false
        },
        definition: {
            type: String,
            required: false
        },
    },
    data() {
        return {
            'steps': {
                1: {
                    'id': 'index',
                    'label': '1. Upload bestand'
                },
                2: {
                    'id': 'map',
                    'label': '2. Kolommen'
                },
                3: {
                    'id': 'validate',
                    'label': '3. Validatie'
                },
                4: {
                    'id': 'import',
                    'label': '4. Importeer'
                }
            },
            title: '',
            description: '',
            templateUrl: '',
            fixedTemplate: false,
            partialExecution: false,
            importPresentation: {},

            step: 1,
            importId: '',
            importHashId: '',

            includeHeaders: false,
            columns: [],
            excelColumns: [],
            columnMapping: {},
            worksheetMappings: [],
            excelWorksheets: [],
            activeWorksheetMapping: '',

            report: {},
            errors: {},

            gridLink: null,
            queueStarted: false,

            loading: false,
        }
    },
    methods: {
        nextStep() {
            this.step++;
        },
        prevStep() {
            this.step--;
        },
        goToStep(step) {
            if (step <= this.activeStep) {
                this.step = parseInt(step);
            }
        },
        async fetchFormData(path) {
            if (!path) path = this.baseGridUri;

            const params = this.addVariablesToDataFetchParams;

            const defaultTemplateUrl = this.$appKitUrl() + this.baseGridUri + 'getTemplate';

            // Otherwise, just get the new data
            try {
                const data = await this.$get(path, params);

                this.title = data.title;
                this.description = data.descr;
                this.templateUrl = data.hasTemplate === false
                    ? ''
                    : (data.templateUrl ? data.templateUrl : defaultTemplateUrl);
                this.columns = data.columns;
                this.fixedTemplate = Boolean(data.fixedTemplate);
                this.partialExecution = Boolean(data.partialExecution);
                this.importPresentation = data.importPresentation || {};
            } catch (error) {
                this.showError = true;
                console.log(error);
            }
        },
        /**
         * Get the uploaded import file metadata from the upload form.
         *
         * @param {Object} form
         * @return {Object|null}
         */
        getUploadedImportFile(form) {
            if (!form || !form.formValues || !Array.isArray(form.formValues.files) || !form.formValues.files.length) {
                return null;
            }

            return form.formValues.files[0];
        },
        /**
         * Create the import after the upload metadata is available.
         *
         * @return {Promise<void>}
         */
        async createImport() {
            this.loading = true;

            const path = this.baseGridUri + 'createImport';

            const form = this.$refs.uploadForm;
            const uploadedFile = this.getUploadedImportFile(form);

            if (!uploadedFile) {
                this.loading = false;
                return;
            }

            const params = {
                'filename': uploadedFile.fileName,
                'originalFilename': uploadedFile.originalFilename,
            }

            // send uploaded file to backend to save import
            try {
                const data = await this.$post(path, params);
                if (data.success) {
                    this.importId = data.importId;
                    this.importHashId = data.importHashId;
                    this.excelColumns = data.excelColumns;
                    this.fixedTemplate = Boolean(data.fixedTemplate);
                    this.worksheetMappings = data.worksheetMappings || [];
                    this.excelWorksheets = data.excelWorksheets || [];
                    this.initializeWorksheetMappings();
                    this.nextStep();
                    if (this.fixedTemplate) {
                        await this.mapColumns();
                    }
                }
            } catch (error) {
                this.showError = true;
                console.log(error);
            }

            this.loading = false;
        },
        async mapColumns() {
            this.loading = true;

            this.errors = {};
            if (!this.fixedTemplate) {
                this.validateMapping();
            }

            if (!Object.keys(this.errors).length) {
                const path = this.baseGridUri + 'mapColumns';

                const params = {
                    'importId': this.importId,
                    'columnMapping': this.columnMapping,
                    'includeHeaders': this.includeHeaders,
                    'worksheetMappings': this.worksheetMappings,
                }

                try {
                    const data = await this.$post(path, params);

                    if (data.success) {
                        this.report = data.report;
                        this.nextStep();
                    }
                } catch (error) {
                    this.showError = true;
                    console.log(error);
                }
            }

            this.loading = false;
        },
        async doImport() {
            if (this.canImport) {
                this.loading = true;

                const path = this.baseGridUri + 'doImport';

                const params = {
                    'importId': this.importId,
                }

                try {
                    const data = await this.$post(path, params);

                    if (data.success) {
                        this.queueStarted = true;
                        this.gridLink = data.gridLink;
                        this.nextStep();
                    }
                } catch (error) {
                    this.showError = true;
                    console.log(error);
                }

                this.loading = false;
            }
        },
        validateMapping() {
            if (this.worksheetMappings.length) {
                this.worksheetMappings.forEach((worksheet) => {
                    const mapping = worksheet.mapping || {};
                    if (!mapping.sourceSheet) {
                        this.errors[worksheet.id + '-sourceSheet'] = 'Gelieve een tabblad te selecteren';
                    }
                    worksheet.columns.forEach((column) => {
                        if (column.required && mapping.columnMapping[column.id] === undefined) {
                            this.errors[worksheet.id + '-' + column.id] = 'Gelieve een kolom te selecteren';
                        }
                    });
                });
                return;
            }

            this.columns.forEach((column) => {
                if (column.required && this.columnMapping[column.id] === undefined) {
                    this.errors[column.id] = 'Gelieve een kolom te selecteren';
                }
            })
        },
        initializeWorksheetMappings() {
            if (!this.worksheetMappings.length) {
                return;
            }

            this.worksheetMappings.forEach((worksheet) => {
                worksheet.mapping = {
                    sourceSheet: this.getBestWorksheetSource(worksheet),
                    includeHeaders: true,
                    columnMapping: {},
                };
                this.matchWorksheetColumns(worksheet);
            });
            this.activeWorksheetMapping = this.worksheetMappings[0].id;
        },
        getWorksheetColumns(worksheet) {
            const source = this.excelWorksheets.find((candidate) => candidate.value === worksheet.mapping.sourceSheet);
            return source ? source.columns : [];
        },
        getBestWorksheetSource(worksheet) {
            if (this.excelWorksheets.some((source) => source.value === worksheet.sourceSheet)) {
                return worksheet.sourceSheet;
            }

            const expected = worksheet.columns.map((column) => this.normalizeColumnName(column.id));
            let bestSource = '';
            let bestScore = 0;
            this.excelWorksheets.forEach((source) => {
                const score = source.columns.filter((column) => expected.includes(this.normalizeColumnName(column.header))).length;
                if (score > bestScore) {
                    bestSource = source.value;
                    bestScore = score;
                }
            });

            return bestSource;
        },
        matchWorksheetColumns(worksheet) {
            const columns = this.getWorksheetColumns(worksheet);
            worksheet.columns.forEach((column) => {
                if (worksheet.mapping.columnMapping[column.id] !== undefined) {
                    return;
                }
                const expected = this.normalizeColumnName(column.id);
                const match = columns.find((source) => this.normalizeColumnName(source.header) === expected);
                if (match) {
                    this.$set(worksheet.mapping.columnMapping, column.id, match.value);
                }
            });
        },
        normalizeColumnName(value) {
            return String(value || '').toLowerCase().replace(/[^a-z0-9]/g, '');
        }
    },
    mounted() {
        this.fetchFormData();

        this.step = this.$route && this.$route.query.step ? parseInt(this.$route.query.step) : 1;
    },
    created() {
        this.baseGridUri = `/${this.activeBundle}/${this.activeDefinition}/`;
    }
}, 'import/ak-import.html');
